import { render, staticRenderFns } from "./ModalEditarResponseDelegateRequisicao.vue?vue&type=template&id=6af5ef64&scoped=true"
import script from "./ModalEditarResponseDelegateRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarResponseDelegateRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarResponseDelegateRequisicao.vue?vue&type=style&index=0&id=6af5ef64&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5ef64",
  null
  
)

export default component.exports